import { ColumnElement } from '@atoms/columnElement';
import { DateFormatPicker } from '@atoms/dateFormat/dateFormat';
import { EditorOptions } from '@library/tableEditor/shared/editor.options';
import type { AtomModel } from '@models/atom.model';
import type { TableEditorDateColumnData } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';

type Props = {
  atom: AtomModel<TableEditorDateColumnData>;
};

export const DateEditor = observer(({ atom }: Props) => (
  <EditorOptions
    atomId={atom.id}
    onPlaceholderChange={value =>
      (atom.data.editorOptions.editors.date.placeholder = value)
    }
    placeholder={atom.data.editorOptions.editors.date.placeholder}
  >
    <ColumnElement>
      <DateFormatPicker
        format={atom.data.editorOptions.editors.date.inputFormat}
        id={`${atom.id}-input-format`}
        label="Stored date format"
        onFormatChange={v =>
          (atom.data.editorOptions.editors.date.inputFormat = v)
        }
      />
    </ColumnElement>
    <ColumnElement>
      <DateFormatPicker
        format={atom.data.editorOptions.editors.date.displayFormat}
        id={`${atom.id}-display-format`}
        label="Display format"
        onFormatChange={v =>
          (atom.data.editorOptions.editors.date.displayFormat = v)
        }
      />
    </ColumnElement>
  </EditorOptions>
));
